import(/* webpackMode: "eager" */ "/home/ubuntu/download/69837da0921dc900148a67aa/atithiniwas/src/app/property-details/page.tsx");
